// extracted by mini-css-extract-plugin
export default {"card":"RoundResult_card__-m01G","card-winner":"RoundResult_card-winner__ltqvs"};